import { AddressElement } from '@stripe/react-stripe-js';
import type { StripeAddressElementOptions } from '@stripe/stripe-js';

interface AddressFieldProps {
  defaultValues?: StripeAddressElementOptions['defaultValues'];
  googleMapsApiKey?: string;
}

export function AddressField({ defaultValues, googleMapsApiKey }: AddressFieldProps) {
  return (
    <AddressElement
      options={{
        mode: 'billing',
        display: {
          name: 'full',
        },
        fields: {
          phone: 'never',
        },
        autocomplete: googleMapsApiKey
          ? { mode: 'google_maps_api', apiKey: googleMapsApiKey }
          : { mode: 'automatic' },
        defaultValues,
      }}
    />
  );
}
